export const interviewScheduleConstants = {
  LOAD: 'interviewSchedule/LOAD',
  LOAD_INNER: 'interviewSchedule/LOAD_INNER',
  LOAD_SUCCESS: 'interviewSchedule/LOAD_SUCCESS',
  LOAD_FAIL: 'interviewSchedule/LOAD_FAIL',
  // Reset reducer
  RESET_MESSAGE: 'interviewSchedule/RESET_MESSAGE',
  GET_APPOINTMENTS: 'interviewSchedule/GET_APPOINTMENTS',
};
